import { PGA_COM_HOST } from 'env'
import React from 'react'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import ErrorOutlineIcon from 'components/material-symbol/icons/ErrorOutline'
import EmptyPageState from 'components/group-event-card/registration-full/empty-page-state'

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#fff',
    margin: `${theme.spacing(4)}px auto`,
  },
}))

const RegistrationInviteRevoked = () => {
  const classes = useStyles()

  return (
    <Container maxWidth="sm" className={classes.container}>
      <EmptyPageState
        IconComp={() => <ErrorOutlineIcon fontSize="large" />}
        title="Invitation revoked"
        caption="The coach revoked this registration invite. Contact the coach if you have questions."
        buttonText="Find Events Near You"
        actionFn={() => window.open(`${PGA_COM_HOST}/golf-lessons`)}
      />
    </Container>
  )
}

export default RegistrationInviteRevoked
